/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './mwl-item.reducer';

export const MWLItem = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const mWLItemList = useAppSelector(state => state.mWLItem.entities);
  const loading = useAppSelector(state => state.mWLItem.loading);
  const totalItems = useAppSelector(state => state.mWLItem.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="mwl-item-heading" data-cy="MWLItemHeading">
        <Translate contentKey="tinyMedicRestApp.mWLItem.home.title">MWL Items</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.mWLItem.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/mwl-item/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.mWLItem.home.createLabel">Create new MWL Item</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.mWLItem.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {mWLItemList && mWLItemList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.id">Id</Translate> <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('accessionNo')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.accessionNo">Accession No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('accessionNo')} />
                </th>
                <th className="hand" onClick={sort('createdTime')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.createdTime">Created Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdTime')} />
                </th>
                <th className="hand" onClick={sort('institution')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.institution">Institution</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('institution')} />
                </th>
                <th className="hand" onClick={sort('department')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.department">Department</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('department')} />
                </th>
                <th className="hand" onClick={sort('localAet')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.localAet">Local Aet</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('localAet')} />
                </th>
                <th className="hand" onClick={sort('modality')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.modality">Modality</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modality')} />
                </th>
                <th className="hand" onClick={sort('reqProcId')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.reqProcId">Req Proc Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('reqProcId')} />
                </th>
                <th className="hand" onClick={sort('spsId')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.spsId">Sps Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('spsId')} />
                </th>
                <th className="hand" onClick={sort('spsStartDate')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.spsStartDate">Sps Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('spsStartDate')} />
                </th>
                <th className="hand" onClick={sort('spsStartTime')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.spsStartTime">Sps Start Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('spsStartTime')} />
                </th>
                <th className="hand" onClick={sort('spsStatus')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.spsStatus">Sps Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('spsStatus')} />
                </th>
                <th className="hand" onClick={sort('studyIuid')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.studyIuid">Study Iuid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('studyIuid')} />
                </th>
                <th className="hand" onClick={sort('updatedTime')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.updatedTime">Updated Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('updatedTime')} />
                </th>
                <th className="hand" onClick={sort('dicomAttrs')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.dicomAttrs">Dicom Attrs</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dicomAttrs')} />
                </th>
                <th className="hand" onClick={sort('instCode')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.instCode">Inst Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('instCode')} />
                </th>
                <th className="hand" onClick={sort('deptCode')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.deptCode">Dept Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('deptCode')} />
                </th>
                <th className="hand" onClick={sort('procedurePriority')}>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.procedurePriority">Procedure Priority</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('procedurePriority')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.admission">Admission</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.admidIssuer">Admid Issuer</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.accnoIssuer">Accno Issuer</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.perfPhysName">Perf Phys Name</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.refPhysName">Ref Phys Name</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.mWLItem.reqPhysName">Req Phys Name</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {mWLItemList.map((mWLItem, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/mwl-item/${mWLItem.id}`} color="link" size="sm">
                      {mWLItem.id}
                    </Button>
                  </td>
                  <td>{mWLItem.accessionNo}</td>
                  <td>{mWLItem.createdTime}</td>
                  <td>{mWLItem.institution}</td>
                  <td>{mWLItem.department}</td>
                  <td>{mWLItem.localAet}</td>
                  <td>{mWLItem.modality}</td>
                  <td>{mWLItem.reqProcId}</td>
                  <td>{mWLItem.spsId}</td>
                  <td>{mWLItem.spsStartDate}</td>
                  <td>{mWLItem.spsStartTime}</td>
                  <td>{mWLItem.spsStatus}</td>
                  <td>{mWLItem.studyIuid}</td>
                  <td>{mWLItem.updatedTime}</td>
                  <td>{mWLItem.dicomAttrs}</td>
                  <td>{mWLItem.instCode}</td>
                  <td>{mWLItem.deptCode}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ProcedurePriority.${mWLItem.procedurePriority}`} />
                  </td>
                  <td>{mWLItem.admission ? <Link to={`/admission/${mWLItem.admission.id}`}>{mWLItem.admission.id}</Link> : ''}</td>
                  <td>{mWLItem.admidIssuer ? <Link to={`/hospital/${mWLItem.admidIssuer.id}`}>{mWLItem.admidIssuer.id}</Link> : ''}</td>
                  <td>{mWLItem.patient ? <Link to={`/gluco-user/${mWLItem.patient.id}`}>{mWLItem.patient.id}</Link> : ''}</td>
                  <td>{mWLItem.accnoIssuer ? <Link to={`/diag-lab/${mWLItem.accnoIssuer.id}`}>{mWLItem.accnoIssuer.id}</Link> : ''}</td>
                  <td>{mWLItem.perfPhysName ? <Link to={`/doctor/${mWLItem.perfPhysName.id}`}>{mWLItem.perfPhysName.id}</Link> : ''}</td>
                  <td>{mWLItem.refPhysName ? <Link to={`/doctor/${mWLItem.refPhysName.id}`}>{mWLItem.refPhysName.id}</Link> : ''}</td>
                  <td>{mWLItem.reqPhysName ? <Link to={`/doctor/${mWLItem.reqPhysName.id}`}>{mWLItem.reqPhysName.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/mwl-item/${mWLItem.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/mwl-item/${mWLItem.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/mwl-item/${mWLItem.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.mWLItem.home.notFound">No MWL Items found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={mWLItemList && mWLItemList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default MWLItem;
